'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.itemProduct = twentyninetimes.itemProduct || function () {

	function init() {
		let hasProducts = document.querySelector('.item-product');

		if ( hasProducts ) {
      window.addEventListener('click', function(e) {
        var target = e.target;
        if ( target.closest('.item-product') ) {
          var product = target.closest('.item-product');

          productImageChanger(product);

          productImageZoom(product);
        }
      });
		}
	}

  function productImageChanger(product) {
    var productImage = product.querySelector('.js-product-image img'),
        productThumbnails = product.querySelector('.js-product-thumbnails');

    if ( !productImage || !productThumbnails ) return;
      
    productThumbnails.addEventListener('click', function(e) {
      e.stopPropagation();
      var target = e.target;

      if ( target.tagName === 'IMG' ) {
        var targetBtn = target.closest('button');

        if ( targetBtn.classList.contains('current') ) return;

        var src = target.getAttribute('src');
        productImage.setAttribute('src', src);

        var currentThumbnail = productThumbnails.querySelector('button.current');

        currentThumbnail.classList.remove('current');
        targetBtn.classList.add('current');

        scrollToImage(productThumbnails, targetBtn);
      }
    });
  }

  function scrollToImage(container, element) {
    const scrollLeft = element.offsetLeft - 20;
    console.log(scrollLeft);
    container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
    });
  }

  function productImageZoom(product) {
    var productImage = product.querySelector('.js-product-image');

    productImage.addEventListener('click', function(e) {
      e.stopPropagation();
      
      if ( !product.classList.contains('slider-mode') ) {
        product.classList.add('slider-mode');
        // product.classList.add('product-info-hidden');

        // setTimeout(function() {
        //   product.classList.add('product-info-pos-abs', 'slider-mode');
        // }, 300);
      } else {
        product.classList.remove('slider-mode');
        
        // setTimeout(function() {
        //   product.classList.remove('product-info-pos-abs', 'product-info-hidden');
        // }, 600);
      }
    });
  }

  return {
		init : init
	};

}();